<template>
    <div v-if="model && form">
        <rkm-area no-margin-top title="Filtros" type="fieldset">
            <rkm-form ref="Form" show-legens>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            start-label="Data inicial"
                            end-label="Data final"
                            :range-inline="false"
                            range
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Sala de vacinação"
                            :options="form.salasVacinacao"
                            v-model="model.salaVacinacaoId"
                            show-default-option
                            default-option-text="Todas"
                            text-field="nomeFantasia"
                            value-field="id"
                            
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Vacina"
                            :options="form.vacinas"
                            v-model="model.vacinaId"
                            show-default-option
                            default-option-text="Todas"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Incluir dados de campanha"
                            :options="form.dadosCampanha"
                            v-model="model.dadosCampanha"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="list"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            color="secondary"
                            @click="clearForm"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area no-margin-top title="Resultado" v-if="items">
            <template v-slot:trailing>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                hide-filters
                hide-pagination
            />
        </rkm-area>
        
        <rkm-area no-margin-top title="Totais" v-if="items">
            <rkm-table
                :fields="fieldsTotal"
                :items="totais"
                hide-filters
                hide-pagination
            />
        </rkm-area>


        <rkm-area
            title="Total"
            type="fieldset"
            no-margin-top
            v-if="items"
        >
           <rkm-row>
                <rkm-col cols="4">
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { error, permissao, formats, object, repository, stringCase, file } from '@/mixins'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    created() {
        this.repositories = {
            relatorioConsolidadoAplicacao: this.getConectaSusRepository('imunizacao.relatorioConsolidadoAplicacao'),
            exportacao: this.getConectaSusRepository('exportacao.imunizacao'),
            impressao: this.getConectaSusRepository('impressao.imunizacao')
        }
        this.load()
    },
    data: () => ({
        model: null,
        form: null,
        items: null,
        totais: null,
        total: null
    }),
    computed: {
        fields() {
            return [
                {
                    key: 'salaVacinacao',
                    label: 'Sala vacinação',
                    sortable: true
                },
                {
                    key: 'vacina',
                    label: 'Vacina',
                    sortable: true
                },
                {
                    key: 'doses',
                    label: 'Doses aplicadas',
                },
            ];
        },
        fieldsTotal() {
            return [
                {
                    key: 'salaVacinacao',
                    label: 'Sala vacinação',
                    sortable: true
                },
                {
                    key: 'doses',
                    label: 'Total',
                },
            ];
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.relatorioConsolidadoAplicacao.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSalasVacinacao() {
            this.setLoading()
            this.repositories.relatorioConsolidadoAplicacao.getSalasVacinacao({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD')
            })
                .then(({ data }) => {
                    this.form.salasVacinacao = data
                    if(data.length == 1) {
                        this.model.salaVacinacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getVacinas() {
            this.setLoading()
            this.repositories.relatorioConsolidadoAplicacao.getVacinas({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                sala_vacinacao_id: this.model.salaVacinacaoId
            })
                .then(({ data }) => {
                    this.form.vacinas = data
                    if(data.length == 1) {
                        this.model.vacinaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.setLoading()
            this.repositories.relatorioConsolidadoAplicacao.list({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                sala_vacinacao_id: this.model.salaVacinacaoId,
                vacina_id: this.model.vacinaId,
                dados_campanha: this.model.dadosCampanha
            })
                .then(({ data }) => {
                    this.items = data.registros
                    this.totais = data.totais
                    this.total = data.total
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioConsolidadoAplicacao({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                sala_vacinacao_id: this.model.salaVacinacaoId,
                vacina_id: this.model.vacinaId,
                dados_campanha: this.model.dadosCampanha
            })
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioConsolidadoAplicacao({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                sala_vacinacao_id: this.model.salaVacinacaoId,
                vacina_id: this.model.vacinaId,
                dados_campanha: this.model.dadosCampanha
            })
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearForm() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.salaVacinacaoId = null
            this.model.vacinaId = null
            this.model.dadosCampanha = 1
            this.items = null
        }
    },
    watch: {
        'model.periodo.start': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getSalasVacinacao()
                this.getVacinas()
            }
            this.items = null
        },
        'model.periodo.end': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getSalasVacinacao()
                this.getVacinas()
            }
            this.items = null
        },
        'model.salaVacinacaoId': function() {
            if(this.model.salaVacinacaoId) {
                this.getVacinas()
            }
            this.items = null
        },
        'model.vacinaId': function() {
            this.items = null
        },
        'model.dadosCampanha': function() {
            this.items = null
        }
    },
    mixins: [ error, permissao, formats, object, repository, stringCase, file ]
}
</script>